import { useEffect, useState } from "react";

interface LeaderboardRanking {
  usr_addr: string;
  score: string;
}

type IProps = {
  index: number;
};

function LeaderboardContent({ index }: IProps) {
  const [leaderboardList, setLeaderboardList] = useState<LeaderboardRanking[]>(
    []
  );
  useEffect(() => {
    let isMounted = true;
    fetch(`https://cbridge-stat.s3.us-west-2.amazonaws.com/test/getCampaignScores_${index + 1}.json`, {
      mode: 'cors',
      headers: {
        'Access-Control-Allow-Origin':'*'
      }
    })
      .then((res) => res.json())
      .then((result) => {
        if (!isMounted) {
          return;
        }
        if (result["err"]) {
          return;
        }
        const res = result["scores"] as LeaderboardRanking[];
        if (res && res.length > 0) {
          setLeaderboardList(res);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [index, leaderboardList]);

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 5fr 1fr",
          columnGap: 8,
          textAlign: "left",
          fontWeight: 650,
          height: 54,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>Rank</div>
        <div style={{ display: "flex", alignItems: "center" }}>ETH Address</div>
        <div style={{ display: "flex", alignItems: "center" }}>Score</div>
      </div>
      {leaderboardList?.map((e, index) => {
        return (
          <div
            key={e.usr_addr}
            style={{ width: "100%", display: "flex", flexFlow: "column" }}
          >
            <div
              style={{
                width: "100%",
                height: 1,
                background: "black",
                opacity: 0.2,
              }}
            />
            <div
              style={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "1fr 5fr 1fr",
                columnGap: 8,
                textAlign: "left",
                fontWeight: 650,
                height: 60,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {index}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {e.usr_addr}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {e.score}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default LeaderboardContent;
